import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class UpdateBlogs extends Component {
  state = {
    allCategories: [],
    blog_id: "",
    blog_category: "",
    blogs_title: "",
    blogs_poster: null,
    blog_content: "",
    blog_tags: "",
    notification: false,
    message: "",
    redirect: false,
  };

  componentDidMount() {
    const blog_id = window.location.pathname.split("/").pop();
    this.setState({ blog_id }, () => {
      this.getAllBlogCategories();
      this.getBlogDetails();
    });
  }

  getAllBlogCategories = () => {
    if (init() !== "success") return window.location.assign("/signin");

    axios.get(`${Constants.getUrls.getAllBlogCategories}?page=1&limit=100`).then((resp) => {
      if (resp.data.status === "success") {
        this.setState({ allCategories: resp.data.data });
      }
    });
  };

  getBlogDetails = () => {
    axios.get(`${Constants.getUrls.getAllBlogs}/${this.state.blog_id}`).then((resp) => {
      if (resp.data.status === "success") {
        const blog = resp.data.data;
        this.setState({
          blogs_title: blog.blogs_title,
          blog_category: blog.blog_category,
          blog_content: blog.blog_content,
          blog_tags: blog.blog_tags,
        });
      }
    });
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDescription = (content) => {
    this.setState({ blog_content: content });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("id", this.state.blog_id);
    fd.append("blog_category", this.state.blog_category);
    fd.append("blogs_title", this.state.blogs_title);
    fd.append("blog_content", this.state.blog_content);
    fd.append("blog_tags", this.state.blog_tags);

    if (this.state.blogs_poster) {
      fd.append("blogs_poster", this.state.blogs_poster);
    }

    axios
      .put(Constants.putUrls.updateBlogs + this.state.blog_id, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data.message,
        });
        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2500);
      })
      .catch((err) => {
        console.log(err);

        this.setState({
          notification: true,
          message: err.response?.data?.message || "Update failed",
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/blogs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg">
              <MDTypography variant="h6" color="white">
                Update Blog
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      label="Blog Title"
                      name="blogs_title"
                      value={this.state.blogs_title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      type="file"
                      label="Blog Poster"
                      focused
                      onChange={(e) => this.setState({ blogs_poster: e.target.files[0] })}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Blog Tags"
                      name="blog_tags"
                      value={this.state.blog_tags}
                      onChange={this.handleInput}
                      fullWidth
                      style={{
                        marginTop: "13px",
                      }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Select Blog Category</InputLabel>
                    <Select
                      value={this.state.blog_category}
                      onChange={(e) => this.setState({ blog_category: e.target.value })}
                      fullWidth
                      style={{ height: "45px" }}
                    >
                      {this.state.allCategories.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.category}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <SunEditor
                      setContents={this.state.blog_content}
                      onChange={this.handleDescription}
                      setOptions={{
                        height: 180,
                        buttonList: [
                          ["undo", "redo"],
                          ["bold", "italic", "underline"],
                          ["align", "list"],
                          ["link", "image", "video"],
                          ["removeFormat"],
                        ],
                      }}
                    />
                  </Grid>
                </Grid>

                <MDBox mt={2}>
                  <MDButton type="submit" variant="contained" color="info">
                    Update Blog
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="VASA Admin"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
